import React from "react";

const SchoolCreditBalancesSearchForm = ({
  student,
  setStudent,
  searchCreditBalances,
  resetSearch,
  setPage
}) => {
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchCreditBalances(e);
  };

const handleStudentChange = (e) => {
    const value = e.target.value;
    setStudent(value);
    setPage(1);
    if (value === '') {
      resetSearch(e);
    }
};

  return (
    <form className="mg-t-20" onSubmit={handleSearchSubmit}>
      <div className="row gutters-8">
        <div className="col-9-xxxl col-xl-6 col-lg-12 col-12 form-group">
          <div className="row">
          <div className="col-lg-12 mt-2">
              <input
                type="text"
                placeholder="Enter student name..."
                style={{ border: "1px solid grey" }}
                value={student}
                onChange={handleStudentChange}
                className="form-control"
              />
            </div>
          </div>
        </div>

        <div className="col-3-xxxl col-xl-6 col-lg-12 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
        </div>
      </div>
    </form>
  );
};

export default SchoolCreditBalancesSearchForm;